// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const EditTool = createSvgIcon(
  { All: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1.5741 11.5976l4.6176-4.7942C6.0714 6.3976 6 5.9448 6 5.5 6 3.0147 8.0147 1 10.5 1c.7184 0 1.3975.1683 2 .4678L10 4S9 5 9 5.5c0 .8284.6716 1.5 1.5 1.5C11 7 12 6 12 6l2.5322-2.5A4.4816 4.4816 0 0115 5.5c0 2.4853-2.0147 4.5-4.5 4.5-.4463 0-.9008-.072-1.3078-.193L4.426 14.4024m-.0156.0157A1.9934 1.9934 0 013 15c-1.1046 0-2-.8954-2-2 0-.5384.2127-1.0271.5587-1.3866" /></React.Fragment>, },
  'small'
);
